import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Home::MwHomeLayout>\n  <Routable::AmbassadorsRoute />\n</Home::MwHomeLayout>",{ moduleName: "mewe/templates/cms/ambassadors.hbs" })